const selectors = {
  accordionButtonSelector: '.js-accordion-button',
  accordionContentSelector: '.js-accordion-content',
  accordionItemSelector: 'accordion-item'
}

// Accordion item
class AccordionItem extends HTMLElement {
  constructor () {
    super()

    this.button = this.querySelector(selectors.accordionButtonSelector)
    this.content = this.querySelector(selectors.accordionContentSelector)
    this.showMore = this.querySelector('.js-show-more')

    this.contentHeight = this.content.scrollHeight

    this.state = {
      open: this.button.getAttribute('aria-expanded') === 'true'
    }
  }

  connectedCallback () {
    this.setScrollHeightCssVar()
    this.attachEvents()
  }

  setScrollHeightCssVar () {
    this.style.setProperty('--scroll-height', `${this.contentHeight}px`)
  }

  attachEvents () {
    if (!this.button) return

    this.button.addEventListener('click', this.toggle.bind(this))
    this.button.addEventListener('keydown', (e) => {
      if (e.keyCode === 13 || e.keyCode === 32) {
        e.preventDefault()
        this.toggle()
      }
    })

    if (!this.showMore) return

    this.showMore.addEventListener('click', () => {
      const showMoreContainer = this.showMore.closest('.js-show-more-container')
      if (showMoreContainer) {
        showMoreContainer.classList.toggle('show-more')
        const contentHeight = this.content.scrollHeight
        this.style.setProperty('--scroll-height', `${contentHeight}px`)
      }
    })
  }

  toggle () {
    if (this.state.open) this.close()
    else this.open()
  }

  open () {
    this.state.open = true
    this.classList.add('is-open')
    this.dispatchEvent(new Event('open'))

    if (this.button) {
      this.button.setAttribute('aria-expanded', true)
      this.button.setAttribute('aria-label', this.button.getAttribute('aria-label').replace('Open', 'Close'))
    }
  }

  close () {
    this.state.open = false
    this.classList.remove('is-open')
    this.dispatchEvent(new Event('close'))

    if (this.button) {
      this.button.setAttribute('aria-expanded', false)
      this.button.setAttribute('aria-label', this.button.getAttribute('aria-label').replace('Close', 'Open'))
    }
  }
}

customElements.define('accordion-item', AccordionItem)

//Accordion wrapper
class AccordionWrapper extends HTMLElement {
  constructor () {
    super ()

    this.listAccordions = Array.from(this.querySelectorAll(selectors.accordionItemSelector))
  }

  connectedCallback () {
    this.watchEvents()
  }

  watchEvents() {
    this.listAccordions.map(accordion => {
      accordion.addEventListener('open', () => this.onOpen(accordion))
    })
  }

  onOpen(accordion) {
    this.listAccordions.map(acc => {
      if (acc !== accordion && acc.state.open) {
        acc.close()
      }
    })
  }
}

customElements.define('accordion-wrapper', AccordionWrapper)
